import React, { useState } from 'react';
import { UploadCloud } from 'lucide-react';
import Tesseract from 'tesseract.js';
import * as pdfjsLib from 'pdfjs-dist';
import { collectFileData } from '../services/ocrService';

// Configurar o worker do pdf.js via CDN
pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js';
export const ImageOCR = () => {
  const [file, setFile] = useState(null);
  const [text, setText] = useState('');
  const [meta, setMeta] = useState(null);
  const [loading, setLoading] = useState(false);

  // Função para converter PDF para imagem (Blob)
  const pdfToImage = async (pdfBlob) => {
    const arrayBuffer = await pdfBlob.arrayBuffer();
    const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;
    const page = await pdf.getPage(1); // Primeira página
    const viewport = page.getViewport({ scale: 2.0 }); // Aumenta qualidade

    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    canvas.height = viewport.height;
    canvas.width = viewport.width;

    await page.render({
      canvasContext: context,
      viewport,
    }).promise;

    return new Promise((resolve) => {
      canvas.toBlob(resolve, 'image/jpeg', 0.95); // JPEG de alta qualidade
    });
  };

  const handleFile = async (e) => {
    const f = e.target.files[0];
    if (!f) return;

    setFile(f);
    setMeta(collectFileData(f));
    setLoading(true);
    setText('');

    try {
      let imageBlob;

      if (f.type === 'application/pdf') {
        console.log('Processando PDF...');
        imageBlob = await pdfToImage(f);
      } else if (f.type.startsWith('image/')) {
        imageBlob = f;
      } else {
        alert('Arquivo não suportado. Use imagens ou PDF.');
        setLoading(false);
        return;
      }

      // Executar OCR com Tesseract
      const result = await Tesseract.recognize(imageBlob, 'por', {
        logger: (info) => {
          console.log('OCR Progress:', info);
        },
      });

      setText(result.data.text);
    } catch (err) {
      console.error('Erro no processamento:', err);
      alert('Erro no processamento: ' + (err.message || 'Desconhecido'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="tool">
      <h2>OCR - Extrair Texto de Imagem/PDF</h2>
      <label className="upload-label" style={{ cursor: 'pointer', textAlign: 'center', padding: '20px', border: '2px dashed #ccc', borderRadius: '8px', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px' }}>
        <UploadCloud size={40} />
        <span>Arraste ou clique para selecionar imagem ou PDF</span>
        <input
          type="file"
          accept="image/*,.pdf"
          onChange={handleFile}
          hidden
        />
      </label>

      {loading && (
        <p style={{ textAlign: 'center', color: '#007bff', marginTop: '10px' }}>
          Processando com OCR... (isso pode levar alguns segundos)
        </p>
      )}

      {meta && (
        <details style={{ marginTop: '20px' }}>
          <summary>Dados do arquivo</summary>
          <pre>{JSON.stringify(meta, null, 2)}</pre>
        </details>
      )}

      {text && (
        <div style={{ marginTop: '20px' }}>
          <h3>Texto Extraído ({meta?.extension.toUpperCase()})</h3>
          <textarea
            value={text}
            readOnly
            rows={12}
            style={{
              width: '100%',
              padding: '10px',
              border: '1px solid #ddd',
              borderRadius: '4px',
              fontFamily: 'monospace',
              backgroundColor: '#f8f9fa',
            }}
          />
        </div>
      )}
    </div>
  );
};

export default ImageOCR;
